import { render, staticRenderFns } from "./CuratedLockIcon.vue?vue&type=template&id=0b451944&"
import script from "./CuratedLockIcon.vue?vue&type=script&lang=js&"
export * from "./CuratedLockIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports